module.exports = __webpack_public_path__ + "img/edit-form.ba55920b.png";